import eventTypes from './event-types.js';

export default class LayoutShiftEvent extends CustomEvent {
  /**
   * @param {CustomEventInit} eventInit
   */
  constructor(eventInit = {}) {
    super(eventTypes.layoutShift, { bubbles: true, ...eventInit });
  }
}
